import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  list2lpjhmv1d2k19 as list,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance3ftsl9x5arf2y as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from '../SavePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInput_InputAdapterClass;
function SavePlayerInput_InputAdapter() {
  if (SavePlayerInput_InputAdapterClass === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Input type used in output position');
      }
      toJson_js48jy_k$(writer, customScalarAdapters, value) {
        writer.name_i73qwh_k$('partyId');
        get_partyIdAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.partyId_1);
        writer.name_i73qwh_k$('playerId');
        get_playerIdAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.playerId_1);
        writer.name_i73qwh_k$('name');
        get_StringAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.name_1);
        writer.name_i73qwh_k$('email');
        get_StringAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.email_1);
        writer.name_i73qwh_k$('badge');
        Badge_ResponseAdapter_instance.toJson_hgkibm_k$(writer, customScalarAdapters, value.badge_1);
        writer.name_i73qwh_k$('callSignAdjective');
        get_StringAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.callSignAdjective_1);
        writer.name_i73qwh_k$('callSignNoun');
        get_StringAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.callSignNoun_1);
        var tmp = value.imageURL_1;
        if (tmp instanceof Present()) {
          writer.name_i73qwh_k$('imageURL');
          present(get_NullableStringAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.imageURL_1);
        }
        var tmp_0 = value.avatarType_1;
        if (tmp_0 instanceof Present()) {
          writer.name_i73qwh_k$('avatarType');
          present(get_NullableStringAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.avatarType_1);
        }
        writer.name_i73qwh_k$('unvalidatedEmails');
        list(get_StringAdapter()).toJson_t3q33c_k$(writer, customScalarAdapters, value.unvalidatedEmails_1);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_js48jy_k$(writer, customScalarAdapters, value instanceof SavePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePlayerInput_InputAdapterClass = $;
  }
  return SavePlayerInput_InputAdapterClass;
}
var SavePlayerInput_InputAdapter_instance;
function SavePlayerInput_InputAdapter_getInstance() {
  return SavePlayerInput_InputAdapter_instance;
}
//region block: init
SavePlayerInput_InputAdapter_instance = new (SavePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePlayerInput_InputAdapter_instance as SavePlayerInput_InputAdapter_instance3fw9b8k7xujxv,
};
//endregion

//# sourceMappingURL=SavePlayerInput_InputAdapter.mjs.map
